(function ($) {

    'use strict';

    var $document = $(document),
        on = function (event, selector, fn) {
            $document.on(event, selector, fn);
        };

    $(function () {

        if( typeof acf === 'undefined' ) {
            return;
        }

        on('click', 'a.esf-user-font-removal', function (e) {
            e.preventDefault();

            var $button = $( this ),
                $spinner = $('<i class="fa fa-spinner fa-spin m-l-10"></i>');

            if ( $button.attr('disabled') ) {
                return;
            }

            $spinner.appendTo( $button );
            $button.attr('disabled', true );

            $.post( ajaxurl, {
                'action' : 'esf-user-font-removal',
                'font' : $button.data('font'),
                'security' : esf_nonces.esf_user_font_removal
            }, function (resp) {
                $button.closest('p').remove();
            });

        });

        var refresh_styles = function() {
            var $style = $('.acf-field-5bc05efaf3213 p.esf-style:not(.refreshed)'),
                $spinner = $('<i class="fa fa-spinner fa-spin m-r-10"></i>')

            if ( $style.length === 0 ) {
                location.reload();
                return;
            }

            $style = $style.first();

            $style.prepend( $spinner );

            $.post( ajaxurl, {
                'action' : 'esf-user-font-refresh',
                'font' : $style.data('family'),
                'security' : esf_nonces.esf_user_font_refresh
            }, function (resp) {
                $spinner.remove();
                $style.addClass('refreshed');
                refresh_styles();
            });
        };

        on('click', '.acf-field-5ee0a12c8e7c7 div.acf-button-group', function (e) {
            e.preventDefault();

            var $button = $( this );

            if ( $button.attr('disabled') ) {
                return;
            }

            $button.attr('disabled', true );

            refresh_styles();

        });

    });

})(jQuery);
